import React from 'react';
import NavigationSecondary from './NavigationSecondary';
import ContentBackgroundArt from './ContentBackgroundArt';

const Layout = (props) => {
    return (
        <div
            style={
                {
                    position: `relative`,
                    display: `flex`,
                    width: `100%`,
                    height: `100%`,
                    flexDirection: `column`,
                    overflowY: `auto`,
                    overflowX: 'hidden',
                    ...(props.style ? props.style : {})
                }
            }
            className={props.className}
        >
            {props.contentBackgroundArt &&
                <ContentBackgroundArt />
            }
            {props.children}
            {props.navSecondaryShow ?
                <NavigationSecondary centered={true} />
                : null}
        </div>
    )
}

export default Layout;
